import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SecurityService } from "src/app/shared/services/security.service";
import { EstadoRecorridoService } from 'src/app/services/estado-recorrido.service';
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import * as _ from "lodash";
import { RecorridoService } from "src/app/services/recorrido.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { RutService } from "src/app/shared/services/rut.service";
import { ConsultaRecorridoDetalleComponent } from './modal-detalle/modal-consulta-recorrido-detalle.component';
import { ModalSeleccionarClienteComponent } from "../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component";
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'app-consulta-recorrido',
  templateUrl: './consulta-recorrido.component.html',
  styleUrls: ['./consulta-recorrido.component.scss'],
  providers: [SecurityService],
})
export class ConsultaRecorridoComponent implements OnInit {

  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = "_RB_TIPO_VISTA_RESUMEN_"
  readonly RB_TIPO_VISTA_DETALLE: String = "_RB_TIPO_VISTA_DETALLE_"

  // Form
  formHeader: FormGroup

  // Utils
  private log: any

  //Modales
  @ViewChild(ConsultaRecorridoDetalleComponent, { static: true }) modalConsultaRecorridoDetalle: ConsultaRecorridoDetalleComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  cliente: any = null;


  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private resumen_currentPayload: any = null
  resumen_loading: boolean = false
  resumen_listaMovimientos: Array<any> = null
  resumen_listaMovimientosAll: Array<any> = null
  resumen_paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null

  private detalle_currentPayload: any = null
  detalle_loading: boolean = false
  detalle_listaMovimientos: Array<any> = null
  detalle_listaMovimientosAll: Array<any> = null
  detalle_paginationContext: PaginationContext = new PaginationContext()
  detalle_totales: any = null

  constructor(
    private accesolocalstorage: SecurityService,
    private estadoRecorrido: EstadoRecorridoService,
    private clog: ConsoleService,
    private datesService: DatesService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private recorridoService: RecorridoService,
    private fileDownloadService: FileDownloadService,
    private rutService: RutService,
  ) {
    this.log = this.clog.log('CONSULTA RECORRIDO')
  }

  optionsEstado: Array<any> = [];

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10
    this.detalle_paginationContext.RecordsByPage = 10
    this.createForm()
    this.loadEstadoRecorrido()
    this.formChangesSubscriptions();
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
      });
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      listaEstado: [[]],
      codigoRecorrido: [null],
      rutCliente: [null, []],
      nroDoc: [null, []]
    });
  }
  
  private loadEstadoRecorrido() {
    //Estado Recorrido
    this.estadoRecorrido.GetByEstadoRecorrido(({ respuesta }) => {
      const { registros } = respuesta
      this.optionsEstado = registros.map(estado => ({ value: estado.codigo, label: estado.nombre, ...estado }))
      //this.setDefaultDoctoReferencia()
    })
  }

  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber)
    this.detalleBuscar(pageNumber)
  }

  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.resumen_paginationContext.CurrentPage = pageNumber

    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, listaEstado, codigoRecorrido, rutCliente, nroDoc } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaEstado,
        codigo: codigoRecorrido === null ? 0 : codigoRecorrido,
        cliente_proveedor_rut: rutCliente === null ? 0 : this.rutService.QuitarDV(rutCliente),
        folio: nroDoc === null ? 0 : nroDoc
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
    this.resumen_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true

    this.recorridoService.ObtenerConsultaRecorridoVistaResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.resumen_loading = false
        return
      }

      const { registros } = respuesta
      this.resumen_listaMovimientosAll = registros
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage) //totalPaginas
      this.resumen_paginationContext.CurrentPage = pageNumber
      this.resumen_listaMovimientosAll.forEach((mov, index) => {
        mov.rutChoferFormato = this.rutService.AgregarDV(mov.chofer_rut)
      })
      this.showPageResumen(this.resumen_paginationContext.CurrentPage)
      this.calculateTotalesResumen()
      this.resumen_loading = false
    })
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage)
  }

  calculateTotalesResumen() {
    if (!(this.resumen_listaMovimientosAll && this.resumen_listaMovimientosAll.length)) {
      this.resumen_totales = {
        total_documentos: 0, total_liq: 0, efectivo: 0, transferencia: 0, deposito: 0,
        cheque: 0, nota_credito: 0, nota_debito: 0, cobro_vendedor: 0, anticipo: 0, reverso: 0, cargo_transp: 0
      }
      return
    }
    this.resumen_totales = {
      total_documentos: _.sumBy(this.resumen_listaMovimientosAll, 'total_documentos'),
      total_liq: _.sumBy(this.resumen_listaMovimientosAll, 'total_liq'),
      efectivo: _.sumBy(this.resumen_listaMovimientosAll, 'efectivo'),
      transferencia: _.sumBy(this.resumen_listaMovimientosAll, 'transferencia'),
      deposito: _.sumBy(this.resumen_listaMovimientosAll, 'deposito'),
      cheque: _.sumBy(this.resumen_listaMovimientosAll, 'cheque'),
      nota_credito: _.sumBy(this.resumen_listaMovimientosAll, 'nota_credito'),
      nota_debito: _.sumBy(this.resumen_listaMovimientosAll, 'nota_debito'),
      cobro_vendedor: _.sumBy(this.resumen_listaMovimientosAll, 'cobro_vendedor'),
      anticipo: _.sumBy(this.resumen_listaMovimientosAll, 'anticipo'),
      reverso: _.sumBy(this.resumen_listaMovimientosAll, 'reverso'),
      cargo_transp: _.sumBy(this.resumen_listaMovimientosAll, 'cargo_transp'),
    }
  }

  resumenOnPageChange(context: PaginationContext) {
    this.showPageResumen(context.RequestedPage)
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))
    // const docIndex: number = this.listaMovimientosAll.findIndex(doc => doc.id_lsoft === id_lsoft)
    // const doc: any = this.listaMovimientosAll[docIndex]
    //doc.loadingPdf = true
    this.recorridoService.ObtenerConsultaRecorridoVistaResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      //doc.loadingPdf = false
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showInfoMessages(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.detalle_paginationContext.CurrentPage = pageNumber

    const { fechaDesde, fechaHasta, listaEstado, codigoRecorrido, rutCliente, nroDoc } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaEstado,
        codigo: codigoRecorrido === null ? 0 : codigoRecorrido,
        cliente_proveedor_rut: rutCliente === null ? 0 : this.rutService.QuitarDV(rutCliente),
        folio: nroDoc === null ? 0 : nroDoc
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
    this.detalle_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.detalle_loading = true
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null

    this.recorridoService.ObtenerConsultaRecorridoVistaDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.detalle_listaMovimientosAll = registros
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage) //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1
      this.detalle_listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage)
      this.calculateTotalesDetalles()
      this.detalle_loading = false
    })
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage)
  }

  calculateTotalesDetalles() {
    const soloDetalle = (this.detalle_listaMovimientosAll || []).filter(m => m.codigo === 0)
    this.detalle_totales = {
      monto_neto: _.sumBy(this.detalle_listaMovimientosAll, 'monto_neto'),
      descuento: _.sumBy(this.detalle_listaMovimientosAll, 'descuento'),
      neto_total: _.sumBy(this.detalle_listaMovimientosAll, 'neto_total'),
      total_documentos: _.sumBy(soloDetalle, 'total_documentos'),
      total_liq: _.sumBy(soloDetalle, 'total_liq'),
      efectivo: _.sumBy(soloDetalle, 'efectivo'),
      transferencia: _.sumBy(soloDetalle, 'transferencia'),
      deposito: _.sumBy(soloDetalle, 'deposito'),
      cheque: _.sumBy(soloDetalle, 'cheque'),
      nota_credito: _.sumBy(soloDetalle, 'nota_credito'),
      nota_debito: _.sumBy(soloDetalle, 'nota_debito'),
      cobro_vendedor: _.sumBy(soloDetalle, 'cobro_vendedor'),
      anticipo: _.sumBy(soloDetalle, 'anticipo'),
      reverso: _.sumBy(soloDetalle, 'reverso'),
      cargo_transp: _.sumBy(soloDetalle, 'cargo_transp')
    }
  }

  detalleOnPageChange(context: PaginationContext) {
    // this.detalleBuscar(context.RequestedPage)
    this.showPageDetalle(context.RequestedPage)
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.recorridoService.ObtenerConsultaRecorridoVistaDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  showConsultaRecorridoDetalle(documento) {
    this.modalConsultaRecorridoDetalle.loadAndShow(documento)
  }

  LimpiarData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.reset();
    this.formHeader.get("tipoVista").setValue(this.RB_TIPO_VISTA_RESUMEN)
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get("listaEstado").setValue([])
    this.formHeader.get("codigoRecorrido").setValue(null)
    this.formHeader.get('rutCliente').setValue(null)
    this.cliente = null
    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null
  }

  openModalSeleccionarcliente() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data, origen }) {
    this.cliente = data
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut)
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato)
  }

  onClienteNoEncontrado() {
    this.cliente = null
  }
}
